import React from 'react';

const VARIANT_STYLES = {
  text: 'rounded h-4',
  block: 'rounded-lg',
  circle: 'rounded-full',
  rect: 'rounded-md',
};

const Skeleton = ({
  variant = 'block',
  width,
  height,
  lines = 1,
  className = '',
  style = {},
}) => {
  const base = 'bg-app-surface-hover animate-pulse';
  const shape = VARIANT_STYLES[variant] || VARIANT_STYLES.block;

  if (variant === 'text' && lines > 1) {
    return (
      <div className={`flex flex-col gap-2 ${className}`} style={{ width, ...style }}>
        {Array.from({ length: lines }).map((_, i) => (
          <div
            key={i}
            className={`${base} ${shape}`}
            style={{ width: i === lines - 1 ? '70%' : '100%', height }}
          />
        ))}
      </div>
    );
  }

  return (
    <div
      className={`${base} ${shape} ${className}`}
      style={{ width, height, ...style }}
    />
  );
};

export default Skeleton;
